module.exports = __webpack_public_path__ + "static/media/Logo.fcfb27f8.jpg";